/**
 * Pro feature guard for @paperjsx/json-to-pdf.
 *
 * Free build (__PRO__=false): throws PaperJSXFeatureError (dead-code eliminated in free bundle).
 * Pro build (__PRO__=true): validates PAPERJSX_LICENSE_KEY. No key = throws. Invalid key = throws.
 */
import { validateLicenseKey, PaperJSXFeatureError } from '@paperjsx/license';

declare const __PRO__: boolean;
export const IS_PRO = typeof __PRO__ !== "undefined" ? __PRO__ : false;

function getPdfLicenseValidationResult() {
  const key = process.env.PAPERJSX_LICENSE_KEY;
  if (!key) {
    return {
      key: undefined,
      result: { valid: false, error: "No license key provided" },
    };
  }

  return {
    key,
    result: validateLicenseKey(key, "pdf"),
  };
}

export function hasPdfProLicense(): boolean {
  if (!IS_PRO) {
    return false;
  }
  return getPdfLicenseValidationResult().result.valid;
}

export function assertPdfPackageLicense(feature = "PDF rendering"): void {
  if (!IS_PRO) {
    return;
  }

  const { key, result } = getPdfLicenseValidationResult();
  if (!key) {
    throw new PaperJSXFeatureError(
      `"${feature}" requires a valid PaperJSX Pro license key. Set PAPERJSX_LICENSE_KEY. See https://paperjsx.com/pricing`,
      feature,
    );
  }
  if (!result.valid) {
    throw new PaperJSXFeatureError(
      `"${feature}": ${result.error}`,
      feature,
    );
  }
}

export function requirePdfPro(feature: string): void {
  if (!IS_PRO) {
    throw new PaperJSXFeatureError(
      `"${feature}" requires @paperjsx/json-to-pdf-pro. See https://paperjsx.com/pricing`,
      feature,
    );
  }
  assertPdfPackageLicense(feature);
}
